module.exports = __webpack_public_path__ + "static/id-buzz-a960d49ea72d34d44fb9c8bdeffd7b37.png";